import type { TranslationDict } from '../en';

const mr: TranslationDict = {
  'header.buy': 'खरेदी करा',
  'header.sell': 'विका',
  'spend.label': 'तुम्ही खर्च करता',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',
  'receive.label': 'तुम्हाला मिळेल',
  'payment.label': 'पेमेंट पद्धत',
  'payment.select': 'निवडा',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'या जोडीसाठी कोणतीही पेमेंट पद्धत उपलब्ध नाही',
  'wallet.label': 'प्राप्तकर्ता वॉलेट पत्ता',
  'wallet.placeholderBuy': 'तुमचा प्राप्तकर्ता पत्ता प्रविष्ट करा',
  'wallet.placeholderSell': 'तुमचा पाठवण्याचा पत्ता प्रविष्ट करा',
  'wallet.validating': 'पत्ता सत्यापित होत आहे...',
  'wallet.invalid': 'वैध वॉलेट पत्ता प्रविष्ट करा',
  'wallet.invalidServer': 'अवैध वॉलेट पत्ता',
  'cta.buy': '{crypto} खरेदी करा',
  'cta.sell': '{crypto} विका',
  'cta.gettingPrice': 'सर्वोत्तम किंमत मिळवत आहे...',
  'cta.processing': 'प्रक्रिया होत आहे...',
  'footer.poweredBy': 'द्वारे समर्थित ',
  'footer.brand': 'NowRamp',
  'rate.title': 'दर तपशील',
  'rate.close': 'बंद करा',
  'rate.updatesIn': 'दर 00:{seconds} मध्ये अपडेट होईल',
  'rate.noQuote': 'कोणतेही कोटेशन उपलब्ध नाही',
  'rate.exchangeRate': 'विनिमय दर',
  'rate.processingFee': 'प्रक्रिया शुल्क',
  'rate.networkFee': 'नेटवर्क शुल्क',
  'rate.provider': 'प्रदाता',
  'toast.orderCreated': 'ऑर्डर तयार केला',
  'toast.redirecting': 'चेकआउटकडे पुनर्निर्देशित होत आहे...',
  'toast.orderFailed': 'ऑर्डर अयशस्वी',
  'toast.couldNotCreate': 'ऑर्डर तयार करता आला नाही',
  'toast.quoteError': 'कोटेशन त्रुटी',
  'toast.noProviders': 'कोणतेही प्रदाता नाही',
  'toast.somethingWrong': 'काहीतरी चुकले',
  'error.amountZero': 'रक्कम 0 पेक्षा जास्त असणे आवश्यक आहे',
  'error.minAmountFiat': 'किमान रक्कम {min} {currency} आहे',
  'error.minAmountCrypto': 'किमान रक्कम {min} {currency} आहे',
  'error.noProviders': 'या संयोजनासाठी कोणतेही प्रदाता उपलब्ध नाहीत',
  'error.currencyUnavailableBuy': 'ही चलन खरेदी ऑर्डरसाठी उपलब्ध नाही',
  'error.currencyUnavailableSell': 'ही चलन विक्री ऑर्डरसाठी उपलब्ध नाही',
  'parity.info': 'तुम्हाला {receiveAmount} {crypto} साठी शुल्क आकारले जाईल, उर्वरित {spendAmount} {fiat} पर्यंत तुमच्या {partner} खात्यात जमा केले जाईल',
  'redirect.secureBadge': 'सुरक्षित पेमेंट',
  'redirect.title': 'पेमेंट सुरू ठेवा',
  'redirect.description': 'तुमचे पेमेंट पूर्ण करण्यासाठी तुम्हाला {gateway} वर पुनर्निर्देशित केले जाईल.',
  'redirect.countdown': '{seconds} मध्ये पुनर्निर्देशित होत आहे...',
  'redirect.openTab': 'नवीन टॅबमध्ये ACH उघडा',
  'redirect.cancel': 'रद्द करा',
  'checkout.noOrder': 'कोणताही ऑर्डर सापडला नाही',
  'checkout.goBack': 'मागे जा',
  'checkout.expired': 'चेकआउटची मुदत संपली',
  'checkout.expiredDesc': 'सत्र कालबाह्य झाले आहे. कृपया पुन्हा प्रयत्न करा.',
  'checkout.startOver': 'पुन्हा सुरू करा',
  'checkout.cancel': 'रद्द करा',
  'checkout.loading': 'चेकआउट लोड होत आहे...',
  'checkout.iframeTitle': 'प्रदाता चेकआउट',
  'checkout.widgetTitle': 'पेमेंट चेकआउट',
  'checkout.unknownMethod': 'अज्ञात चेकआउट पद्धत',
  'processing.default': 'तुमचा ऑर्डर प्रक्रिया होत आहे...',
  'processing.pending': 'पेमेंट पुष्टीकरणाची प्रतीक्षा आहे...',
  'processing.active': 'तुमचा व्यवहार प्रक्रिया होत आहे...',
  'processing.generic': 'प्रक्रिया होत आहे...',
  'processing.checkingStatus': 'स्थिती तपासत आहे...',
  'processing.orderId': 'ऑर्डर आयडी',
  'processing.provider': 'प्रदाता',
  'processing.amount': 'रक्कम',
  'processing.receiving': 'मिळत आहे',
  'processing.network': 'नेटवर्क',
  'processing.toAddress': 'प्राप्तकर्ता पत्ता',
  'processing.usuallyMinutes': 'यास सहसा काही मिनिटे लागतात.',
  'processing.safeToClose': 'तुम्ही हे पेज सुरक्षितपणे बंद करू शकता - पूर्ण झाल्यावर आम्ही तुम्हाला ईमेल पाठवू.',
  'complete.buyTitle': 'खरेदी पूर्ण!',
  'complete.sellTitle': 'विक्री पूर्ण!',
  'complete.buyDesc': 'तुमचे {crypto} तुमच्या वॉलेटमध्ये पाठवले गेले आहे.',
  'complete.sellDesc': 'तुमचे {fiat} पेआउट प्रक्रिया होत आहे.',
  'complete.amountBuy': 'प्राप्त रक्कम',
  'complete.amountSell': 'विकलेली रक्कम',
  'complete.paidBuy': 'दिलेली रक्कम',
  'complete.paidSell': 'पेआउट रक्कम',
  'complete.network': 'नेटवर्क',
  'complete.wallet': 'वॉलेट',
  'complete.transaction': 'व्यवहार',
  'complete.provider': 'प्रदाता',
  'complete.orderId': 'ऑर्डर आयडी',
  'complete.completed': 'पूर्ण',
  'complete.viewExplorer': 'एक्सप्लोररवर पाहा',
  'complete.done': 'झाले',
  'errorStep.failed': 'पेमेंट अयशस्वी',
  'errorStep.cancelled': 'ऑर्डर रद्द केला',
  'errorStep.expired': 'ऑर्डर कालबाह्य',
  'errorStep.refunded': 'ऑर्डर परत केला',
  'errorStep.unknown': 'काहीतरी चुकले',
  'errorStep.failedBuy': 'तुमचे पेमेंट प्रक्रिया होऊ शकले नाही. कृपया पुन्हा प्रयत्न करा किंवा वेगळी पेमेंट पद्धत वापरा.',
  'errorStep.failedSell': 'तुमची विक्री प्रक्रिया होऊ शकली नाही. कृपया पुन्हा प्रयत्न करा.',
  'errorStep.cancelledBuy': 'तुमचा ऑर्डर रद्द केला गेला. कोणतेही पेमेंट प्रक्रिया झाले नाही.',
  'errorStep.cancelledSell': 'तुमची विक्री रद्द केली गेली. कोणतेही क्रिप्टो हस्तांतरित केले नाही.',
  'errorStep.expiredBuy': 'तुमचा ऑर्डर कालबाह्य झाला आहे. कृपया नवीन खरेदी सुरू करा.',
  'errorStep.expiredSell': 'तुमचा ऑर्डर कालबाह्य झाला आहे. कृपया नवीन विक्री सुरू करा.',
  'errorStep.refundedBuy': 'तुमचे पेमेंट परत केले गेले आहे. रक्कम 5-10 कार्यदिवसांमध्ये तुमच्या खात्यात दिसेल.',
  'errorStep.refundedSell': 'तुमचे क्रिप्टो परत केले गेले आहे. रक्कम लवकरच तुमच्या वॉलेटमध्ये दिसेल.',
  'errorStep.genericDesc': 'एक अनपेक्षित त्रुटी आली. कृपया पुन्हा प्रयत्न करा.',
  'errorStep.orderId': 'ऑर्डर आयडी',
  'errorStep.tryAgain': 'पुन्हा प्रयत्न करा',
  'errorStep.startOver': 'पुन्हा सुरू करा',
  'errorStep.return': 'परत जा',
  'errorStep.needHelp': 'मदत हवी आहे? संपर्क करा ',
  'errorStep.reference': 'संदर्भ: {orderId}',
  'confirm.buyTitle': 'खरेदी पुष्टी करा',
  'confirm.sellTitle': 'विक्री पुष्टी करा',
  'confirm.loading': 'लोड होत आहे...',
  'confirm.provider': 'प्रदाता',
  'confirm.youPay': 'तुम्ही देता',
  'confirm.youSell': 'तुम्ही विकता',
  'confirm.youReceive': 'तुम्हाला मिळेल',
  'confirm.wallet': 'वॉलेट',
  'confirm.network': 'नेटवर्क',
  'confirm.refundAddress': 'परतावा पत्ता',
  'confirm.parityNote': 'प्रदात्याकडून आकारलेली रक्कम वेगळी असू शकते. उर्वरित {amount} {crypto} पर्यंत तुमच्या {partner} खात्यात जमा केले जाईल.',
  'confirm.processing': 'प्रक्रिया होत आहे...',
  'confirm.confirmPay': 'पुष्टी करा आणि पेमेंट करा',
  'confirm.confirmSell': 'पुष्टी करा आणि विका',
  'confirm.payout': '{currency} पेआउट',
  'modal.selectFiat': 'फिएट चलन निवडा',
  'modal.selectCrypto': 'क्रिप्टो चलन निवडा',
  'modal.choosePayment': 'पेमेंट पद्धत निवडा',
  'modal.selectCountry': 'तुमचा देश निवडा',
  'modal.selectLanguage': 'Select language',
  'modal.popular': 'लोकप्रिय',
  'modal.recommended': 'शिफारस केलेले',
  'modal.noCurrencies': 'कोणतेही चलन सापडले नाही',
  'modal.noPaymentMethods': 'कोणतीही पेमेंट पद्धत सापडली नाही',
  'modal.noCountries': 'कोणताही देश सापडला नाही',
  'modal.noLanguages': 'No languages found',
  'settings.location': 'स्थान',
  'settings.darkMode': 'डार्क मोड',
  'settings.privacy': 'गोपनीयता धोरण',
  'settings.terms': 'वापराच्या अटी',
  'settings.language': 'भाषा',

  // ─── Additional ───
  'modal.chooseRamp': 'Ramp निवडा',
  'modal.bestPrice': 'सर्वोत्तम किंमत',
  'modal.noQuotes': 'या विनंतीसाठी कोणतेही कोटेशन उपलब्ध नाही',
  'modal.noProvidersFound': 'कोणतेही प्रदाता सापडले नाहीत',
  'payment.unavailableFor': '{currency} साठी कोणतीही पेमेंट पद्धत उपलब्ध नाही',
  'skeleton.poweredBy': 'NowRamp द्वारे समर्थित',
  'error.createOrderFailed': 'ऑर्डर तयार करण्यात अयशस्वी',
  'errorStep.returnToMerchant': 'व्यापाऱ्याकडे परत जा',
  'confirm.cryptoOnNetwork': '{crypto} {network} वर',
  'payment.name.card': 'कार्ड',
  'payment.name.bankTransfer': 'बँक ट्रान्सफर',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default mr;
